import { axiosService } from "../axios.service";
import { urls } from "../../constants";

const cycleMenuService = {
    getByDay: (day) =>
        axiosService.get(`${urls.cycleMenu.cycleDishesR}?day=${day}`).then(v => v.data),
    create: (data) =>
        axiosService.post(urls.cycleMenu.cycleDishesR, data).then(v => v.data),
    updateById: (id, data) =>
        axiosService.patch(`${urls.cycleMenu.cycleDishesR}/${id}`, data).then(v => v.data),
    deleteById: (id) =>
        axiosService.destroy(`${urls.cycleMenu.cycleDishesR}/${id}`).then(v => v.data),
};

export { cycleMenuService };
